export default {
  // Materials WriteOff
  SET_MATERIALS_WRITE_OFF:(state, items) => state.materialsWriteOff = items,
  // Cash register
  ADD_PATIENT_PAYMENT(state, patient_payment) {
    state.patientsPayments.push(patient_payment)
    state.patientsPaymentsCount += 1
  },
  EDIT_PATIENT_PAYMENT(state, patient_payment) {
    if (state.patientsPayments && state.patientsPayments.length) {
      const idx = state.patientsPayments.findIndex(payment => payment.id === patient_payment.id)
      if (idx > -1) {
        Object.keys(patient_payment).forEach(key => {
          state.patientsPayments[idx][key] = patient_payment[key]
        })
      }
    }
  },
  SET_PATIENTS_PAYMENTS: (state, items) => state.patientsPayments = items,
  SET_PATIENTS_PAYMENTS_COUNT: (state, count) => state.patientsPaymentsCount = count,
  DELETE_PATIENT_PAYMENT(state, patient_payment_id) {
    const idx = state.patientsPayments.findIndex(patient_payment => patient_payment.id === patient_payment_id)
    state.patientsPayments.splice(idx, 1)
    state.patientsPaymentsCount -= 1
  },
  SET_CASH_REGISTER_TOTAL(state, cash_register_total) {
    state.cash_register_total = cash_register_total
  },
  SET_TOTAL_BY_DIRECTION: (state, data) => state.totalByDirection = data,
  SET_TOTAL_BY_SNAPSHOT(state, total_by_snapshot) {
    state.total_by_snapshot = total_by_snapshot
  },
  SET_TOTAL_BY_SELLING(state, total_by_selling) {
    state.total_by_selling = total_by_selling
  },
  SET_TOTAL_BY_PREPAYMENT(state, total_by_selling) {
    state.total_by_prepayment = total_by_selling
  },
  SET_TOTAL_BY_DISCOUNT(state, total_by_discount) {
    state.total_by_discount = total_by_discount
  },
  // Debtors
  SET_DEBTORS: (state, items) => state.debtors = items,
  // Advances
  SET_ADVANCES: (state, items) => state.advances = items,
  // Insurances
  SET_INSURANCES_PER_PAGE: (state, items) => state.insurancesPerPage = items,
  SET_INSURANCES_PER_PAGE_TOTAL_COUNT: (state, count) => state.insurancesPerPageTotalCount = count,
  // Certificates
  SET_CERTIFICATES(state, items) {
    state.certificates = items
  },
  CERTIFICATE_ADDED(state, item) {
    state.certificates.push(item)
  },
  CERTIFICATE_EDITED(state, certificate) {
    const idx = state.certificates.findIndex(item => item.id === certificate.id)
    Object.keys(certificate).forEach(key => state.certificates[idx][key] = certificate[key])
  },
  DELETE_CERTIFICATE(state, id) {
    const idx = state.certificates.findIndex(c => c.id === id)
    state.certificates.splice(idx, 1)
  },
  SET_CERTIFICATES_PER_PAGE: (state, items) => state.certificatesPerPage = items,
  SET_CERTIFICATES_PER_PAGE_TOTAL_COUNT: (state, count) => state.certificatesPerPageTotalCount = count,
  // Cashless payments
  SET_CASHLESS_PAYMENTS(state, items) {
    state.cashlessPayments = items
  },
  CASHLESS_PAYMENT_ADD(state, item) {
    state.cashlessPayments.push(item)
  },
  CASHLESS_PAYMENT_EDIT(state, item) {
    const idx = state.cashlessPayments.findIndex(payment => payment.id === item.id)
    Object.keys(item).forEach(key => {
      state.cashlessPayments[idx][key] = item[key]
    })
  },
  DELETE_CASHLESS_PAYMENT(state, id) {
    const idx = state.cashlessPayments.findIndex(item => item.id === id)
    state.cashlessPayments.splice(idx, 1)
  },
  SET_GO_TO_PAYMENT_INFO: (state, info) => state.goToPaymentInfo = info
}
